import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, styled, useMediaQuery, useTheme } from "@mui/system";
import PreviewIcon from '@mui/icons-material/Preview';
import Fab from "@mui/material/Fab";
// import InventoryIcon from "@mui/icons-material/Inventory";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import {
  Button,
  Dialog,
  Toolbar,
  DialogContent,
  DialogActions,
  IconButton,
  CircularProgress,
  Backdrop,
  DialogTitle,
  List,
  ListItemButton,
  ListItemText,
  Tooltip,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import AppBar from "@mui/material/AppBar";
import Typography from "@mui/material/Typography";
import useSparePartInfoViewModel from "../viewmodel/SparePartInfoVM";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CButton from "../../../basecomp/components/CButton3";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import CCarousel from "../../../basecomp/components/CCarousel";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import LabelIcon from "@mui/icons-material/Label";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import LabelPopUp from "./LabelPopUp";
import WarehousePopUp from "./WarehousePopUp";
import BackButton from "./BackButton";
import { useTranslation } from "react-i18next";
import { ImageRequired, imageSize, MaterialNumberRequired, MaxImageSelect, MaxImageUpload, maxSizePerFile } from "../../../image_upload/assets/Strings";
import { gblNameOrLocalNameCheck, ImageUpload } from "../../../image_upload/src/model/ImageUpload";
import { useToast } from "../../../basecomp/components/provider/ToastProvider";
import PutAwayModal from "./PutAwayModal";

const OrderBox = styled("div")({
  textAlign: "start",
  border: "1px solid #3CB043",
  width: "100%",
  margin: "1rem 0em",
  borderRadius: "1.2em 1.2em 1em 1em",
});

const OrderBoxBtn = styled("div")({
  padding: "2em 3em",
  display: "flex",
  justifyContent: "center",
});

function SparePartInfoView() {
  const {
    materialDetails,
    handleOpenModal,
    modalOpen,
    setModalOpen,
    error,
    handleChange,
    quantity,
    addToCart,
    popUpBox,
    material_no,
    storage_loc,
    MaterialData,
    handelPutAway,
    setMaterialDetails,
  } = useSparePartInfoViewModel();
  const { t, i18n } = useTranslation();
  const { handleToastOpen } = useToast();

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const OrderBoxText = styled("div")({
    textAlign: "center",
    backgroundColor: "#3CB043",
    color: "white",
    padding: ".5em",
    borderRadius: "0.7em 0.7em 0em 0em",
    fontSize: isXs ? ".9em" : "1.2em",
  });
  const [openCarousel, setOpenCarousel] = useState(false);
  const [openLabel, setOpenLabel] = useState(false);
  const [openWarehouse, setOpenWarehouse] = useState(false);
  const [assetData, setAssetData] = useState([]);
  const infoHeadData1 = [t('loc_bin'), t('ohq'), t('uom')];
  const infoHeadData2 = [t('global_mpn'), t('local_mpn')];
  const [aData1, setAData1] = useState([]);
  const [infoRowData, setInfoRowData] = useState([]);
  const [infoRowData1, setInfoRowData1] = useState([]);
  const [mpn, setMpn] = useState([]);
  const [localMpn, setLocalMpn] = useState([]);
  const [openPutAway, setOpenPutAway] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => {
    sessionStorage.clear();
    navigate("/services");
  };
  useEffect(() => {
    if (
      material_no !== "null"
    ) {
      sessionStorage.setItem(
        "logingsoneurl",
        `/warehouse/spare-part-info?material_no=${material_no}&storage_loc=${storage_loc}`
      );
    }
  }, []);
  const handleLabel = () => {
    setOpenLabel(true);
  };
  const handleWarehouse = () => {
    setOpenWarehouse(true);
  };

  const [materialNumber, setMaterialNumber] = useState("");
  const [binLocation, setBinLocation] = useState("");
  const [storageBinLocation, setStorageBinLocation] = useState("");
  const [loading, setLoading]=useState(false);

  const [selectedImages, setSelectedImages] = React.useState([]);
  const [globalType, setGlobalType] = useState("");
  const [openImageModal, setOpenImageModal] = useState(false);
  // const theme = useTheme();

const isMobileOrTablet =
  useMediaQuery(
    theme.breakpoints.down("md")
  );

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);

    setSelectedImages(files)
  };



  useEffect(() => {
    const clearBackKey = () => {
      localStorage.removeItem("back");
    };

    window.addEventListener("beforeunload", clearBackKey);
    window.addEventListener("unload", clearBackKey);
    window.addEventListener("pagehide", clearBackKey);

    return () => {
      window.removeEventListener("beforeunload", clearBackKey);
      window.removeEventListener("unload", clearBackKey);
      window.removeEventListener("pagehide", clearBackKey);
    };
  }, []);

  useEffect(() => {
    if (Array.isArray(materialDetails) && materialDetails.length > 0) {
      console.log("materialDetails", materialDetails);
      const materialDet = materialDetails[0];
      setMaterialNumber(materialDet?.material_no);
      setBinLocation(materialDet?.bin_location);
      setStorageBinLocation(materialDet?.storage_loc);
      setMpn(materialDet.mpn_links);
      setLocalMpn(materialDet.local_mpn);
      setAssetData([
        [
          {
            name: t("plant"),
            value:
              materialDet.plant_id === undefined ? " " : materialDet.plant_id,
          },
        ],
        [
          {
            name: t("asset_id"),
            value:
              materialDet.asset_id === undefined ||
                materialDet.asset_id === null
                ? "\u00A0"
                : materialDet.asset_id,
          },
        ],
        [
          {
            name: t("local_no"),
            value:
              materialDet?.material_no === undefined ||
                materialDet?.material_no === null
                ? "\u00A0"
                : materialDet?.material_no,
          },
          {
            name: t("local_desc"),
            value:
              materialDet.material_desc === undefined ||
                materialDet.material_desc === null
                ? "\u00A0"
                : materialDet.material_desc,
          },
        ],
        [
          {
            name: t("global_no"),
            value:
              materialDet.gbl_material_number === undefined ||
                materialDet.gbl_material_number === null
                ? "\u00A0"
                : materialDet.gbl_material_number,
          },
          {
            name: t("global_desc"),
            value:
              materialDet.gbl_material_desc === undefined ||
                materialDet.gbl_material_desc === null
                ? "\u00A0"
                : materialDet.gbl_material_desc,
          },
        ],
      ]);
      setInfoRowData([
        { value: `name`, type: "T" },
        { value: `value`, type: "T" },
      ]);

      setAData1([
        {
          storage_loc:
            (materialDet.storage_loc ? materialDet.storage_loc : "") +
            (materialDet.bin_location
              ? `${" / " + materialDet.bin_location}`
              : ""),
          ohqty: materialDet.ohqty,
          b_un: materialDet.b_un,
        },
      ]);
      setInfoRowData1([
        { value: `storage_loc`, type: "T" },
        { value: `ohqty`, type: "T" },
        { value: `b_un`, type: "T" },
      ]);
    }
  }, [materialDetails, i18n.language]);

  const materialSearchRedirect = (material_no) => {
    sessionStorage.clear();
    window.open(
      `/d-catalogue/shopping-basket?lcl_mat_no=${material_no}`,
      "_blank"
    );
  };
  // const handleImageUpload = () => {
  //   sessionStorage.clear();
  //   window.open(
  //     `/warehouse/image-upload?mat_no=${materialNumber}`,
  //     "_blank"
  //   );
  // }
  const handleImageUpload = async (materialReq, selectedImages,) => {

    if (!materialReq) {
      handleToastOpen("error", MaterialNumberRequired);
      return;
    }
    if (!selectedImages || selectedImages.length === 0) {
      handleToastOpen("error", ImageRequired);
      return;
    }
    if (selectedImages.length > 5) {
      handleToastOpen("error", MaxImageSelect);
      return;
    }
    if (selectedImages.length > 5) {
      handleToastOpen("error", MaxImageUpload);
      return;
    }
    // Validate each image size and total size
    let totalSize = 0;

    for (const image of selectedImages) {
      totalSize += image.size;

      if (image.size > maxSizePerFile) {
        handleToastOpen("error", imageSize);
        return;
      }
    }
    setLoading(true);
    const email = localStorage.getItem("email");
    const response = await gblNameOrLocalNameCheck(email);
    setGlobalType(response.data.is_global);
    try {
      await ImageUpload(
        materialReq,
        response.data.is_global,
        selectedImages,
        handleToastOpen
      );
      await MaterialData();
    }
    catch (error) {
      console.log("we are in error", error);
    } finally {
      setLoading(false); // Set loading to false after completion
    }
  }
  return (
    <>
      <LabelPopUp
        open={openLabel}
        onClose={() => setOpenLabel(false)}
        material={materialNumber}
        bin_location={binLocation}
        storage_loc={storageBinLocation}
        setBinLocation={setBinLocation}
        setMaterialDetails={setMaterialDetails}
      />
      <WarehousePopUp
        open={openWarehouse}
        onClose={() => setOpenWarehouse(false)}
        material={materialNumber}
        bin_location={binLocation}
        storage_loc={storageBinLocation}
      />
      {popUpBox ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              position: "relative",
              backgroundColor: "#fff",
              borderRadius: "20px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              width: "80%",
              maxWidth: "400px",
              textAlign: "center",
            }}
          >
            <button
              onClick={handleClose}
              style={{
                position: "absolute",
                top: "20px",
                right: "10px",
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
            >
              <CloseIcon style={{ fontSize: "35px" }} />
            </button>

            <WarningIcon
              style={{
                fontSize: "70px",
                color: "red",
                margin: "60px 30px 0",
              }}
            />
            <p
              style={{
                fontSize: "22px",
                color: "#333",
                lineHeight: "35px",
                fontWeight: "300",
                padding: "0 10px",
              }}
            >
              {t('unauth')}
            </p>

            {/* Close Button */}
            <button
              onClick={handleClose}
              style={{
                background: "none",
                border: "none",
                width: "100%",
                fontSize: "20px",
                cursor: "pointer",
                height: "50px",
                backgroundColor: "red",
                color: "#fff",
                borderRadius: "0 0 10px 10px",
                marginTop: "20px", // Space between text and button
              }}
            >
              {t('close')}
            </button>
          </div>
        </div>
      ) : null}
      <Grid
        item
        xs={10}
        sm={10}
        md={10}
        lg={10}
        xl={10}
        sx={{ margin: "1em 0.5em 0.5em 0.5em" }}
      >
        <BackButton />
        <Card sx={{ padding: "0.5em" }}>

          <Grid
            container
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {materialDetails && (
              <OrderBox>
                <OrderBoxText>{t("general_info")}</OrderBoxText>
                <TableContainer>
                  <Table size="small">
                    <TableBody>
                      {assetData?.map((actualArr, rowIndex) => (
                        <TableRow key={rowIndex}>
                          {infoRowData.map((rowData, cellIndex) => (
                            <TableCell
                              component="th"
                              scope="row"
                              key={cellIndex}
                              sx={{
                                padding: "0em 0.2em 0em 2em",
                                margin: "0em",
                                border: "none",
                                fontWeight: "bold",
                                width: cellIndex === 0 ? "40%" : "60%",
                              }}
                            >
                              {actualArr?.map((actualRow, rowIndex) => (
                                <TableRow key={rowIndex}>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={{
                                      textAlign: "left",
                                      padding: "0.8em 0em 0.8em 0em",
                                      verticalAlign: "middle",
                                      fontSize: "0.9em",
                                      border: "none",
                                    }}
                                  >
                                    {rowData.type === "T" &&
                                      actualRow[rowData.value]}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </OrderBox>
            )}
          </Grid>

          {materialDetails && (
            <>
              <OrderBox sx={{ marginTop: "1em" }}>
                <OrderBoxText>{t("manufacture_info")}</OrderBoxText>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {infoHeadData2?.map((headData, headIndex) => (
                          <TableCell
                            key={headIndex}
                            sx={{
                              textAlign: "center",
                              fontWeight: "bold",
                              width: headIndex === 0 ? "50%" : "50%",
                            }}
                          >
                            {headData}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {mpn.map((link, index) => {
                        const mpnSearchUrl = `https://www.google.com/search?q=${encodeURIComponent(
                          (link.mpn_name ? link.mpn_name : "") +
                          " " +
                          (link.mpn_number ? link.mpn_number : "")
                        )}`;
                        const mpnUrl = link?.mpn_url?.includes("***")
                          ? link.mpn_url.replace(
                            "***",
                            link.mpn_number ? link.mpn_number : ""
                          )
                          : link.mpn_url;

                        return (
                          <TableRow key={index}>
                            {/* Global Manufacturer Info */}
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                textAlign: "center",
                                padding: "0.8em",
                                fontSize: "0.9em",
                                border: "none", // Remove border
                              }}
                            >
                              <a
                                href={link.mpn_url ? mpnUrl : mpnSearchUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#1976d2",
                                  textDecoration: "underline",
                                  display: "block",
                                }}
                              >
                                {link.mpn_name ? link.mpn_name + " - " : ""}{" "}
                                {link.mpn_number ? link.mpn_number : ""}
                              </a>
                            </TableCell>

                            {/* Local Manufacturer Info */}
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                textAlign: "center",
                                padding: "0.8em",
                                fontSize: "0.9em",
                                border: "none", // Remove border
                              }}
                            >
                              {localMpn[index] ? (
                                <a
                                  href={
                                    localMpn[index]?.mpn_url?.includes("***")
                                      ? localMpn[index].mpn_url.replace(
                                        "***",
                                        localMpn[index].mpn_number
                                          ? localMpn[index].mpn_number
                                          : ""
                                      )
                                      : `https://www.google.com/search?q=${encodeURIComponent(
                                        (localMpn[index].mpn_name
                                          ? localMpn[index].mpn_name
                                          : "") +
                                        " " +
                                        (localMpn[index].mpn_number
                                          ? localMpn[index].mpn_number
                                          : "")
                                      )}`
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#1976d2",
                                    textDecoration: "underline",
                                    display: "block",
                                  }}
                                >
                                  {localMpn[index].mpn_name
                                    ? localMpn[index].mpn_name + " - "
                                    : ""}
                                  {localMpn[index].mpn_number
                                    ? localMpn[index].mpn_number
                                    : ""}
                                </a>
                              ) : (
                                <>&nbsp;</> // Empty space for rows with no localMpn
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}

                      {/* Extra rows for Local MPN if localMpn has more items than mpn */}
                      {localMpn?.length > mpn.length &&
                        localMpn.slice(mpn.length).map((link, index) => (
                          <TableRow key={mpn.length + index}>
                            {/* Empty Global Manufacturer Cell */}
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                textAlign: "center",
                                padding: "0.8em",
                                fontSize: "0.9em",
                                border: "none", // Remove border
                              }}
                            >
                              &nbsp;
                            </TableCell>

                            {/* Local Manufacturer Info */}
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                textAlign: "center",
                                padding: "0.8em",
                                fontSize: "0.9em",
                                border: "none", // Remove border
                              }}
                            >
                              <a
                                href={
                                  link?.mpn_url?.includes("***")
                                    ? link.mpn_url.replace(
                                      "***",
                                      link.mpn_number ? link.mpn_number : ""
                                    )
                                    : `https://www.google.com/search?q=${encodeURIComponent(
                                      (link.mpn_name ? link.mpn_name : "") +
                                      " " +
                                      (link.mpn_number
                                        ? link.mpn_number
                                        : "")
                                    )}`
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#1976d2",
                                  textDecoration: "underline",
                                  display: "block",
                                }}
                              >
                                {link.mpn_name ? link.mpn_name + " - " : ""}
                                {link.mpn_number ? link.mpn_number : ""}
                              </a>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </OrderBox>
            </>
          )}

          {materialDetails && (
            <>
              <OrderBox sx={{ marginTop: "3em" }}>
                <OrderBoxText>{t("inventory_details")}</OrderBoxText>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {infoHeadData1?.map((headData, headIndex) => (
                          <TableCell
                            key={headIndex}
                            sx={{
                              textAlign: "center",
                              fontWeight: "bold",
                              width: headIndex === 0 ? "70%" : "15%",
                            }}
                          >
                            {headData}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {aData1?.map((actualRow, rowIndex) => (
                        <TableRow key={rowIndex}>
                          {infoRowData1?.map((rowData, cellIndex) => (
                            <TableCell
                              component="th"
                              scope="row"
                              key={cellIndex}
                              sx={{
                                textAlign: "center",
                                border: "none",
                                width: cellIndex === 0 ? "70%" : "15%",
                              }}
                            >
                              {rowData.type === "T" && actualRow[rowData.value]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </OrderBox>
            </>
          )}
          <Grid item sx={{ marginTop: "3em" }}>
            {materialDetails && (
              <OrderBox>
                <OrderBoxText>{t("links")}</OrderBoxText>
                <OrderBoxBtn>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: { xs: 2, sm: 3 },
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    {materialDetails?.[0]?.image_link?.length > 0 ? (
                      <CButton
                        cId="gsone_sparepartinfo_image_btn_link"
                        cTooltipText={t('ImageView')}
                        cSrc={<PreviewIcon />}
                        cOnClick={() => setOpenCarousel(true)}
                        cIsMain={true}
                      />
                    ) : (
                      // <Box
                      //   display="flex"
                      //   flexDirection="column"
                      //   alignItems="center"
                      // >
                      //   <Button
                      //     component="span"
                      //     variant="contained"
                      //     onClick={() => {
                      //       const fileInput =
                      //         document.getElementById(`image-id`);

                      //       if (fileInput) {
                      //         fileInput.click();
                      //       }
                      //     }}
                      //     sx={{
                      //       fontSize: { xs: "0.75rem", sm: "0.875rem" },
                      //       padding: { xs: "0.5rem", sm: "0.5rem" },
                      //       minHeight: { xs: "40px", sm: "44px" },
                      //       minWidth: { xs: "40px", sm: "44px" },
                      //       display: "flex",
                      //       justifyContent: "center",
                      //       alignItems: "center",
                      //       borderRadius: "6px",

                      //       "& .MuiSvgIcon-root": {
                      //         fontSize: { xs: "1.2rem", sm: "1.5rem" },
                      //       },
                      //     }}
                      //   >
                      //     <CameraAltIcon />

                      //     <input
                      //       id={`image-id`}
                      //       type="file"
                      //       accept="image/*"
                      //       //capture="environment"
                      //       onChange={(e) =>
                      //         handleFileChange(e)
                      //       }
                      //       style={{ display: "none" }}
                      //       multiple
                      //     />
                      //   </Button>

                      //   {selectedImages.length !== 0 && (
                      //     <Button
                      //       variant="contained"
                      //       size="small"
                      //       onClick={() =>
                      //         handleImageUpload(
                      //           materialDetails?.[0]?.material_no,
                      //           selectedImages
                      //         )
                      //       }
                      //       sx={{
                      //         fontSize: 10,
                      //         mt: 1,
                      //       }}
                      //     >
                      //       Upload
                      //     </Button>
                      //   )}
                      // </Box>
<Box
  display="flex"
  flexDirection="column"
  alignItems="center"
>
  {/* CAMERA BUTTON */}
  <Button
    component="span"
    variant="contained"
    onClick={() => {
      // MOBILE + TABLET
      if (isMobileOrTablet) {
        setOpenImageModal(true);
      }

      // LAPTOP + DESKTOP
      else {
        const fileInput =
          document.getElementById(
            "gallery-input"
          );

        if (fileInput) {
          fileInput.click();
        }
      }
    }}
    sx={{
      fontSize: { xs: "0.75rem", sm: "0.875rem" },
      padding: { xs: "0.5rem", sm: "0.5rem" },
      minHeight: { xs: "40px", sm: "44px" },
      minWidth: { xs: "40px", sm: "44px" },
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "6px",

      "& .MuiSvgIcon-root": {
        fontSize: { xs: "1.2rem", sm: "1.5rem" },
      },
    }}
  >
    <CameraAltIcon />
  </Button>

  {/* CAMERA INPUT */}
  <input
    id="camera-input"
    type="file"
    accept="image/*"
    capture="environment"
    onChange={(e) => handleFileChange(e)}
    style={{ display: "none" }}
    multiple
  />

  {/* GALLERY INPUT */}
  <input
    id="gallery-input"
    type="file"
    accept="image/*"
    onChange={(e) => handleFileChange(e)}
    style={{ display: "none" }}
    multiple
  />

  {/* MODAL ONLY FOR MOBILE/TABLET */}
  {isMobileOrTablet && (
    <Dialog
      open={openImageModal}
      onClose={() => setOpenImageModal(false)}
    >
      <DialogTitle>
        Select Option
      </DialogTitle>

      <List>
        {/* CAMERA OPTION */}
        <ListItemButton
          onClick={() => {
            const fileInput =
              document.getElementById(
                "camera-input"
              );

            if (fileInput) {
              fileInput.click();
            }

            setOpenImageModal(false);
          }}
        >
          <ListItemText primary="Open Camera" />
        </ListItemButton>

        {/* GALLERY OPTION */}
        <ListItemButton
          onClick={() => {
            const fileInput =
              document.getElementById(
                "gallery-input"
              );

            if (fileInput) {
              fileInput.click();
            }

            setOpenImageModal(false);
          }}
        >
          <ListItemText primary="Choose From Gallery" />
        </ListItemButton>
      </List>
    </Dialog>
  )}

  {/* UPLOAD BUTTON */}
  {selectedImages.length !== 0 && (
    <Button
      variant="contained"
      size="small"
      onClick={() =>
        handleImageUpload(
          materialDetails?.[0]?.material_no,
          selectedImages
        )
      }
      sx={{
        fontSize: 10,
        mt: 1,
      }}
    >
      Upload
    </Button>
  )}
</Box>
                    )}

                    <CButton
                      cId="gsone_sparepartinfo_matno_btn_search"
                      cTooltipText={t('material_search')}
                      cSrc={<SearchIcon />}
                      cIsMain={true}
                      cOnClick={() =>
                        materialSearchRedirect(materialDetails[0]?.material_no)
                      }
                    />
                    <CButton
                      cId="gsone_sparepartinfo_add_btn_cart"
                      cTooltipText={t('add_to_cart')}
                      cSrc={<ShoppingCartOutlinedIcon />}
                      cOnClick={() => handleOpenModal(materialDetails[0].id)}
                      cIsMain={true}
                    />
                    <CButton
                      cId="gsone_label"
                      cTooltipText={t('mat_label')}
                      cSrc={<LabelIcon />}
                      cIsMain={true}
                      cOnClick={() => handleLabel()}
                    />
                    <CButton
                      cId="gsone_warehouse"
                      cTooltipText={t('warehouse_label')}
                      cSrc={<WarehouseIcon />}
                      cOnClick={() => handleWarehouse()}
                      cIsMain={true}
                    />
                  </Box>
                </OrderBoxBtn>
              </OrderBox>
            )}
          </Grid>
        </Card>
      </Grid>
      {openCarousel && (
        <CCarousel
          cOpen={openCarousel}
          images={materialDetails[0].image_link}
          cClose={() => setOpenCarousel(false)}
        />
      )}

      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        PaperProps={{
          style: {
            marginBottom: "25em",
            maxWidth: "23em",
            width: "100%",
          },
        }}
      >
        <AppBar
          position="static"
          style={{
            backgroundColor: "#3CB043",
            alignItems: "center",
          }}
        >
          <Toolbar>
            <ShoppingCartOutlinedIcon />
          </Toolbar>
        </AppBar>

        <DialogContent>
          <div className="modal-body">
            <Typography
              style={{
                color: "#1976d2",
                marginBottom: "1em",
              }}
            >
              {t('qty')}
            </Typography>
            <TextField
              id="standard-basic"
              fullWidth
              value={quantity}
              onChange={handleChange}
              variant="standard"
            />
            {error && <span>{error}</span>}
          </div>
        </DialogContent>

        <DialogActions>
          <Button style={{ color: "#1976d2" }} onClick={addToCart}>
            {t('ok')}
          </Button>
          <Button
            onClick={() => setModalOpen(false)}
            style={{ color: "#1976d2" }}
          >
            {t('cancel')}
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop
  open={loading}
  sx={{
    zIndex: (theme) => theme.zIndex.drawer + 999 // force above everything
  }}
>
  <CircularProgress />
</Backdrop>
<Tooltip
    title={materialDetails?.[0]?.bin_location?"Put Away":"Cannot perform Put Away. Bin location is not available."}
    placement="left"
    arrow
>
    <span
        style={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 1000,
        }}
    >
        <Fab
            color="primary"
            disabled={!materialDetails?.[0]?.bin_location}
            onClick={() => setOpenPutAway(true)}
        >
            <QrCodeScannerIcon />
        </Fab>
    </span>
</Tooltip>
<PutAwayModal
    open={openPutAway}
    onClose={() => setOpenPutAway(false)}
    materialNo={materialDetails?.[0]?.material_no}
    storageLocation={materialDetails?.[0]?.storage_loc}
    binLocation={materialDetails?.[0]?.bin_location}
    bulkLocation={materialDetails?.[0]?.bulk_location}
    onSuccess={(data,selectedPutAway) => {
      console.log("success qr is valid");
        console.log(data, selectedPutAway);
      handelPutAway(materialDetails?.[0]?.material_no,materialDetails?.[0]?.storage_loc,materialDetails?.[0]?.bin_location,materialDetails?.[0]?.bulk_location,data, selectedPutAway)
    }}
    handleToastOpen={handleToastOpen}
/>
    </>
  );
}

export default SparePartInfoView;
